import { Stack, Typography } from "@mui/material";
import TransitionalRegion from "components/TransitionalRegion";
import VidletLogo from "components/VidletLogo";
import useGetShareByTokenId from "hooks/api/useGetShareByTokenId";
import { useParams } from "react-router-dom";
import { flexCentered } from "theme/base/flex";
import ShareTimelinePlayer from "../components/ShareTimelinePlayer";

const ShareReview = () => {
  const { token } = useParams();
  const { shareVideos, error, isLoading } = useGetShareByTokenId(token);

  return (
    <Stack
      sx={{
        width: "100%",
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100vh",
        height: "100vh",
        maxHeight: "100vh",
        overflow: "hidden",
      }}
    >
      <Stack
        sx={{
          height: "5rem",
          minHeight: "5rem",
          maxHeight: "5rem",
          width: "100%",
          backgroundColor: "white",
          ...flexCentered,
        }}
      >
        <VidletLogo sx={{ fontSize: "3.5rem" }} />
      </Stack>
      <Stack
        sx={{
          flex: 1,
          position: "relative",
          minWidth: "50vw",
          maxHeight: "75vh",
          maxWidth: "100%",
          ...flexCentered,
        }}
        spacing={2}
      >
        <TransitionalRegion showSpinner={isLoading}>
          {error ? (
            <>
              <Typography variant="h5">
                We're sorry. Access to this video has expired.
              </Typography>
              <Typography variant="h6">
                Please reach out to your Vidlet researcher or
                <br /> email{" "}
                <a href="mailto:info@vidlet.com">info@vidlet.com</a> for
                additional access.
              </Typography>
            </>
          ) : (
            <ShareTimelinePlayer timelineItems={shareVideos || []} />
          )}
        </TransitionalRegion>
      </Stack>
    </Stack>
  );
};

export default ShareReview;
